export default async function (context) {
  await context.store.dispatch('store__app__user/initAuth', context.req)
}
